/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ChainlinkV3ReverseAggregator,
  ChainlinkV3ReverseAggregatorInterface,
} from "../ChainlinkV3ReverseAggregator";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract AggregatorV3Interface",
        name: "_aggregator",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "description",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint80",
        name: "_roundId",
        type: "uint80",
      },
    ],
    name: "getRoundData",
    outputs: [
      {
        internalType: "uint80",
        name: "roundId",
        type: "uint80",
      },
      {
        internalType: "int256",
        name: "answer",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "startedAt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "updatedAt",
        type: "uint256",
      },
      {
        internalType: "uint80",
        name: "answeredInRound",
        type: "uint80",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "latestRoundData",
    outputs: [
      {
        internalType: "uint80",
        name: "roundId",
        type: "uint80",
      },
      {
        internalType: "int256",
        name: "answer",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "startedAt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "updatedAt",
        type: "uint256",
      },
      {
        internalType: "uint80",
        name: "answeredInRound",
        type: "uint80",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "version",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ChainlinkV3ReverseAggregatorConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ChainlinkV3ReverseAggregatorConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ChainlinkV3ReverseAggregator__factory extends ContractFactory {
  constructor(...args: ChainlinkV3ReverseAggregatorConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ChainlinkV3ReverseAggregator";
  }

  deploy(
    _aggregator: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ChainlinkV3ReverseAggregator> {
    return super.deploy(
      _aggregator,
      overrides || {}
    ) as Promise<ChainlinkV3ReverseAggregator>;
  }
  getDeployTransaction(
    _aggregator: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_aggregator, overrides || {});
  }
  attach(address: string): ChainlinkV3ReverseAggregator {
    return super.attach(address) as ChainlinkV3ReverseAggregator;
  }
  connect(signer: Signer): ChainlinkV3ReverseAggregator__factory {
    return super.connect(signer) as ChainlinkV3ReverseAggregator__factory;
  }
  static readonly contractName: "ChainlinkV3ReverseAggregator";
  public readonly contractName: "ChainlinkV3ReverseAggregator";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ChainlinkV3ReverseAggregatorInterface {
    return new utils.Interface(_abi) as ChainlinkV3ReverseAggregatorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ChainlinkV3ReverseAggregator {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ChainlinkV3ReverseAggregator;
  }
}
